/**
 * @module
 *
 * @description Investing driver configurations
 */
import { getAccountOpenMin, getAdvisorFee, getAdvisorFeePeriod, getFlatTradePrice, getPromotionDescription, getPromotionValue, getTradePriceCaption } from '../selectors/investing';
import { FORMATS } from '../constants/drivers';
/**
 * Get the account minimum driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverAccountMinimum = function getDriverAccountMinimum(offer) {
  return {
    id: 'accountMinimum',
    label: 'Account minimum',
    value: getAccountOpenMin(offer) || 0,
    valueFormat: FORMATS.CURRENCY
  };
};
/**
 * Get the fees driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverFees = function getDriverFees(offer) {
  var quickFact = {
    id: 'fees',
    label: 'Fees'
  };
  var managementFee = getAdvisorFee(offer);
  var tradeFee = getFlatTradePrice(offer);

  if (managementFee) {
    quickFact.value = managementFee;
    quickFact.description = getAdvisorFeePeriod(offer);
  } else {
    quickFact.value = tradeFee || 0;
    quickFact.valueFormat = FORMATS.CURRENCY_FRACTIONAL;
    quickFact.description = getTradePriceCaption(offer);
  }
  /**
   * Roundups for brokers for options trading have a different description.
   * We are not currently supporting this and will likely need another field on the
   * offer (or roundup) level to indicate this type of page if we do want to support it.
   * For implementation,
   * @see {@link https://github.com/NerdWallet/widget-investing-compare-module/blob/master/client/components/marketplace/marketplace.jsx#L207}
   */


  return quickFact;
};
/**
 * Get the promotion driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverPromotion = function getDriverPromotion(offer) {
  return {
    id: 'promotion',
    label: 'Promotion',
    value: getPromotionValue(offer),
    description: getPromotionDescription(offer)
  };
};